/* BXH Native — buy box : packs + tailles = vraie variante, prix, galerie, ajout au panier (Slide Cart). Vanilla, sans dépendance. */
(function () {
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (fmt || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  function init(root) {
    if (root.__bxhn) return; root.__bxhn = true;
    var data = JSON.parse(root.querySelector('[data-product-json]').textContent);
    var form = root.querySelector('form.bxhn-form');
    var input = root.querySelector('[data-variant-input]');
    var packs = [].slice.call(root.querySelectorAll('[data-pack]'));
    var sizes = [].slice.call(root.querySelectorAll('[data-size]'));
    var track = root.querySelector('[data-track]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));
    var tlist = root.querySelector('[data-tlist]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var chart = root.querySelector('[data-chart]');

    var cur = data.variants.filter(function (v) { return String(v.id) === input.value; })[0] || data.variants[0];
    var state = { o1: cur.o1, o2: cur.o2, o3: cur.o3 == null ? null : cur.o3 };
    var colors = [].slice.call(root.querySelectorAll('[data-color]'));

    function find() {
      return data.variants.filter(function (v) { return v.o1 === state.o1 && v.o2 === state.o2 && (state.o3 == null || v.o3 === state.o3); })[0];
    }
    function slideIndexForMedia(id) {
      var el = track && track.querySelector('[data-media-id="' + id + '"]');
      return el ? +el.getAttribute('data-index') : -1;
    }
    function goTo(i, smooth) {
      if (!track || i < 0) return;
      var s = track.children[i]; if (!s) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0), behavior: smooth ? 'smooth' : 'auto' });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    function update(fromUser) {
      var v = find(); if (!v) return;
      input.value = v.id;
      root.querySelectorAll('[data-price]').forEach(function (e) { e.textContent = money(v.price, data.money_format); });
      root.querySelectorAll('[data-compare]').forEach(function (e) {
        e.hidden = !(v.compare > v.price); e.textContent = money(v.compare, data.money_format);
      });
      root.querySelectorAll('[data-save]').forEach(function (e) {
        var pct = v.compare > v.price ? Math.round((v.compare - v.price) * 100 / v.compare) : 0;
        e.hidden = !pct;
        e.textContent = (e.getAttribute('data-prefix') + ' ' + pct + '% ' + e.getAttribute('data-suffix')).trim();
      });
      var sel = packs.filter(function (p) { return p.getAttribute('data-pack') === state.o1; })[0];
      packs.forEach(function (p) { var on = p === sel; p.classList.toggle('is-selected', on); p.setAttribute('aria-checked', on); });
      if (sel) {
        var pp = sel.querySelector('[data-per-pair]');
        root.querySelectorAll('[data-per-piece]').forEach(function (e) { if (pp) e.textContent = pp.textContent.trim(); });
      }
      sizes.forEach(function (b) { var on = b.getAttribute('data-size') === state.o2; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
      root.querySelectorAll('[data-size-label]').forEach(function (e) { e.textContent = state.o2; });
      colors.forEach(function (b) { var on = b.getAttribute('data-color') === state.o3; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
      if (state.o3 != null) root.querySelectorAll('[data-color-label]').forEach(function (e) { e.textContent = state.o3; });
      var btn = root.querySelector('[data-atc]'), lab = root.querySelector('[data-atc-label]');
      if (btn && lab) { btn.disabled = !v.available; lab.textContent = v.available ? lab.getAttribute('data-label') : lab.getAttribute('data-soldout'); }
      if (fromUser && v.media) goTo(slideIndexForMedia(v.media), true);
      if (fromUser && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString());
      }
    }

    packs.forEach(function (p) {
      p.addEventListener('click', function () { state.o1 = p.getAttribute('data-pack'); update(true); });
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); p.click(); } });
    });
    sizes.forEach(function (b) { b.addEventListener('click', function () { state.o2 = b.getAttribute('data-size'); update(true); }); });
    colors.forEach(function (b) { b.addEventListener('click', function () { state.o3 = b.getAttribute('data-color'); update(true); }); });

    /* Galerie */
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-thumb'), true); }); });
    function step(dir) {
      if (!track) return;
      var w = track.children[0] ? track.children[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    if (next) next.addEventListener('click', function () { step(1); });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (track && (prev || next)) {
      track.addEventListener('scroll', function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft < 2;
        if (next) next.hidden = track.scrollLeft >= max;
      }, { passive: true });
    }
    var up = root.querySelector('[data-thumbs-up]'), down = root.querySelector('[data-thumbs-down]');
    if (up && tlist) up.addEventListener('click', function () { tlist.scrollBy({ top: -123.6, behavior: 'smooth' }); });
    if (down && tlist) down.addEventListener('click', function () { tlist.scrollBy({ top: 123.6, behavior: 'smooth' }); });

    /* Guide des tailles */
    function openChart(e) { if (e) e.preventDefault(); if (chart && chart.showModal) chart.showModal(); }
    root.querySelectorAll('[data-open-chart], a[href="#size-chart"]').forEach(function (a) { a.addEventListener('click', openChart); });
    if (chart) {
      chart.querySelector('[data-close-chart]').addEventListener('click', function () { chart.close(); });
      chart.addEventListener('click', function (e) { if (e.target === chart) chart.close(); });
    }

    /* Ajout au panier : /cart/add.js puis ouverture du tiroir Slide Cart (repli : page panier) */
    function addToCart(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var btn = root.querySelector('[data-atc]'), err = root.querySelector('[data-atc-error]');
      if (btn) btn.classList.add('is-loading');
      if (err) err.hidden = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
      }).then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (item) {
          document.dispatchEvent(new CustomEvent('bxhn:added', { detail: item }));
          if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
          if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
          else location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        })
        .catch(function () { if (err) err.hidden = false; })
        .then(function () { if (btn) btn.classList.remove('is-loading'); });
    }
    /* Bouton type=button : des apps du thème interceptent les boutons submit des formulaires produit. */
    var atcBtn = root.querySelector('[data-atc]');
    if (atcBtn) atcBtn.addEventListener('click', addToCart);
    if (form) form.addEventListener('submit', addToCart);

    update(false);
  }

  function boot() { document.querySelectorAll('.bxhn-main').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
